export default __webpack_public_path__ + "static/media/star3.8769bbae.gif";